
import Select, { SelectItem, SelectProps } from '../components/Select';
import { ClientStatus } from '../common/interfaces/client.interface';

const StatusOptions: SelectItem<string>[] = [
    {
        key: ClientStatus.ACTIVE,
        value: 'Activ'
    },
    {
        key: ClientStatus.INACTIVE,
        value: 'Inactiv'
    },
];

type ClientStatusSelectProps = Omit<SelectProps<string>, 'options'>;

const ClientsStatusSelect = ({ selected, onChange, ...selectProps }: ClientStatusSelectProps) => {
    return (
        <Select
            {...selectProps}
            placeholder={`Status`}
            options={StatusOptions}
            onChange={onChange}
            selected={selected}
        />
    );
};

export default ClientsStatusSelect;
